<template>
  <!-- MD-4 (MD-K4): dönem çipi — Bugün / Bu Hafta / Bu Ay / Özel (+ sayfa tarihsiz başlıyorsa Tümü).
       Seçince v-model:baslangic / v-model:bitis güncellenir ve «degisti» yayınlanır; Özel'de iki
       tarih de seçilince. Aralık hazır dönemle eşleşmiyorsa çip aralığı gösterir: «01.04 – 29.09». -->
  <div class="min-w-0">
    <Button type="button" severity="secondary" outlined icon="pi pi-calendar"
      :label="etiket" class="max-w-full ds-cip" aria-haspopup="true" @click="$refs.pop.toggle($event)" />
    <Popover ref="pop">
      <div class="flex flex-col gap-1 w-64">
        <Button v-for="d in donemler" :key="d.kod" type="button" text
          :severity="aktifKod === d.kod ? 'primary' : 'secondary'" :label="d.ad"
          :icon="aktifKod === d.kod ? 'pi pi-check' : undefined" class="!justify-start" @click="sec(d.kod)" />
        <Button type="button" text :severity="ozelAcik || aktifKod === 'ozel' ? 'primary' : 'secondary'"
          label="Özel" :icon="aktifKod === 'ozel' ? 'pi pi-check' : undefined" class="!justify-start" @click="ozelAcik = true" />
        <div v-if="ozelAcik" class="flex flex-col gap-2 pt-2 border-t border-gray-200 dark:border-gray-700">
          <DatePicker v-model="ozelBas" date-format="dd.mm.yy" :manual-input="false" placeholder="Başlangıç" fluid />
          <DatePicker v-model="ozelBit" date-format="dd.mm.yy" :manual-input="false" placeholder="Bitiş" fluid />
        </div>
      </div>
    </Popover>
  </div>
</template>

<script>
function gun(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
function ayniGun(a, b) {
  return !!(a && b) && gun(a).getTime() === gun(b).getTime();
}
function tarihe(v) {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
}
function kisa(d) {
  return String(d.getDate()).padStart(2, "0") + "." + String(d.getMonth() + 1).padStart(2, "0");
}

export default {
  name: "DonemSecici",
  props: {
    baslangic: { type: [Date, String], default: null },
    bitis: { type: [Date, String], default: null },
  },
  emits: ["update:baslangic", "update:bitis", "degisti"],
  data() {
    return {
      // Sayfa tarihsiz başladıysa (TTS listeleri) «Tümü» seçeneği sunulur.
      tumuVar: !this.baslangic && !this.bitis,
      ozelAcik: false,
      ozelBas: null,
      ozelBit: null,
    };
  },
  computed: {
    donemler() {
      const l = [
        { kod: "bugun", ad: "Bugün" },
        { kod: "hafta", ad: "Bu Hafta" },
        { kod: "ay", ad: "Bu Ay" },
      ];
      return this.tumuVar ? [{ kod: "tumu", ad: "Tümü" }, ...l] : l;
    },
    bas() {
      return tarihe(this.baslangic);
    },
    bit() {
      return tarihe(this.bitis);
    },
    aktifKod() {
      if (!this.bas && !this.bit) return this.tumuVar ? "tumu" : null;
      for (const d of this.donemler) {
        if (d.kod === "tumu") continue;
        const [b, e] = this.aralik(d.kod);
        if (ayniGun(this.bas, b) && ayniGun(this.bit, e)) return d.kod;
      }
      return "ozel";
    },
    etiket() {
      const d = this.donemler.find((x) => x.kod === this.aktifKod);
      if (d) return d.ad;
      if (this.bas && this.bit) return kisa(this.bas) + " – " + kisa(this.bit);
      if (this.bas) return kisa(this.bas) + " –";
      return "Dönem";
    },
  },
  watch: {
    ozelBas() {
      this.ozelDene();
    },
    ozelBit() {
      this.ozelDene();
    },
  },
  methods: {
    aralik(kod) {
      const bugun = gun(new Date());
      if (kod === "bugun") return [bugun, bugun];
      if (kod === "hafta") {
        const b = new Date(bugun);
        b.setDate(b.getDate() - ((b.getDay() + 6) % 7)); // Pazartesi
        return [b, bugun];
      }
      if (kod === "ay") return [new Date(bugun.getFullYear(), bugun.getMonth(), 1), bugun];
      return [null, null];
    },
    // Sayfa tarihi metin tutuyorsa (yyyy-mm-dd) aynı biçimde geri verilir.
    bicimle(d) {
      if (d === null) return null;
      if (typeof this.baslangic === "string" || typeof this.bitis === "string") {
        return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
      }
      return d;
    },
    yay(b, e) {
      this.$emit("update:baslangic", this.bicimle(b));
      this.$emit("update:bitis", this.bicimle(e));
      this.$nextTick(() => this.$emit("degisti"));
    },
    sec(kod) {
      this.ozelAcik = false;
      const [b, e] = this.aralik(kod);
      this.yay(b, e);
      this.$refs.pop.hide();
    },
    ozelDene() {
      if (!this.ozelBas || !this.ozelBit) return;
      const [b, e] = this.ozelBas <= this.ozelBit ? [this.ozelBas, this.ozelBit] : [this.ozelBit, this.ozelBas];
      this.yay(gun(b), gun(e));
      this.ozelBas = null;
      this.ozelBit = null;
      this.ozelAcik = false;
      this.$refs.pop.hide();
    },
  },
};
</script>

<style scoped>
.ds-cip :deep(.p-button-label) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
